import styled, { css } from 'styled-components';

export const CommodityStatusStyled = styled.div`
  display: flex;
  justify-content: space-between;
  box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 1px 10px 0 rgba(0, 0, 0, 0.12), 0 4px 5px 0 rgba(0, 0, 0, 0.14);

  ${({ theme }) => css`
    background-color: ${theme.colors.white};
    padding-left: ${theme.spacings[600]};
    padding-right: ${theme.spacings[600]};
    padding-top: ${theme.spacings[400]};
    padding-bottom: ${theme.spacings[400]};
    margin-bottom: ${theme.spacings[100]};
  `};
`;
